import React from 'react';
import { CheckCircle2, ArrowRight, ShoppingBag } from 'lucide-react';

export default function SubmissionSuccessCard({ responseData, onResetForm }) {
  // Fallbacks if data properties aren't completely populated
  const title = responseData?.title || "Submission Successful!";
  const message = responseData?.message || "Processing Request.";

  return (
    <div style={{
      maxWidth: "500px",
      margin: "40px auto",
      background: "#ffffff",
      border: "1px solid #e2e8f0",
      borderRadius: "16px",
      padding: "32px",
      textAlign: "center",
      boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.05), 0 8px 10px -6px rgba(0, 0, 0, 0.05)",
      fontFamily: "system-ui, sans-serif"
    }}>
      {/* Animated Success Checkmark Ring */}
      <div style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#f0fdf4",
        borderRadius: "50%",
        width: "64px",
        height: "64px",
        color: "#16a34a",
        marginBottom: "20px"
      }}>
        <CheckCircle2 size={36} strokeWidth={2} />
      </div>

      {/* Dynamic Title */}
      <h3 style={{
        fontSize: "22px",
        fontWeight: 700,
        color: "#0f172a",
        margin: "0 0 10px 0",
        letterSpacing: "-0.3px"
      }}>
        {title}
      </h3>

      {/* Supporting Description Body */}
      <p style={{
        fontSize: "14px",
        lineHeight: "1.6",
        color: "#475569",
        margin: "0 0 28px 0"
      }}>
        {message}
      </p>

      {/* Action Buttons Matrix */}
      <div style={{
        display: "flex",
        flexDirection: "column",
        gap: "10px"
      }}>
      </div>
    </div>
  );
}